import React from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import { data } from "../data/offeringSubs.js";

// Import Material-UI icons
import SecurityIcon from '@material-ui/icons/Security';
import CodeIcon from '@material-ui/icons/Code';
import CloudIcon from '@material-ui/icons/Cloud';

export default function OfferingsSubs() {
  // Component state
  const dataValues = data;
  
  // Button configurations with icons and URLs
  const buttons = [
    { 
      label: "CYBER SECURITY", 
      icon: <SecurityIcon />, 
      url: "https://cyber.digital.saicif.com",
      bgColor: "#006BB6", 
      hoverColor: "#00ACD4"
    },
    { 
      label: "APPLICATION DEVELOPMENT", 
      icon: <CodeIcon />, 
      url: "https://appdev.digital.saicif.com",
      bgColor: "#694CDA", 
      hoverColor: "#00ACD4" 
    },
    { 
      label: "PLATFORMS & CLOUD", 
      icon: <CloudIcon />, 
      url: "https://cloud.digital.saicif.com",
      bgColor: "#64696F", 
      hoverColor: "#00ACD4"
    }
  ];

  // Button Styling
  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%', 
    marginTop: '10px'
  };

  // Style for the button component
  const baseButtonStyle = {
    width: '425px', 
    height: '75px', 
    marginBottom: '100px', 
    fontSize: "20px",
    fontWeight: 600,
    textTransform: 'none', 
  };

  return (
    <div className="approachAIContainer">
      <Grid
        container
        xs={11}
        sm={11}
        md={10}
        lg={11}
        spacing={1}
        className="container"
      >
        {/* Buttons Row */}
        <Grid item xs={12}>
          <Grid container spacing={1} justifyContent="center">

            {buttons.map((button) => (
              <Grid item key={button.label}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  component="a"
                  target="_blank"
                  href={button.url}
                  style={{...baseButtonStyle, backgroundColor: button.bgColor}}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = button.hoverColor}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = button.bgColor}
                >
                  
                  <span style={buttonStyle}>
                    {button.icon}
                    <span>{button.label}</span>
                  </span>
                </Button>
              </Grid>
            ))}
            
          </Grid>
        </Grid>

        {/* Content Cards */}
         <Grid item xs={12}>
          <Grid container spacing={1}  >
            {dataValues.map((item, index) => (
              <Grid item xs={12} sm={12} md={4} lg={4} className="columns" key={index}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  alt={item.title}
                >
                  <img src={item.image} alt={item.title} />
                  <div className="spacer" />
                  <Typography className="title">{item.title}</Typography>
                </a>
                <div className="spacer" />
                <Typography className="desc">{item.description}</Typography>

                {(item.title === "Digital Workspace" ) && (
                  <span>
                    <br />
                    <br />
                    <Typography style={{ textAlign: "left" }}>
                      <b>{item.introBullet}</b>
                    </Typography>
                    <ul
                      style={{
                        listStyle: "none",
                        textAlign: "left",
                        marginLeft: "-40px",
                      }}
                    >
                      <li>
                        <Typography className="desc">{item.bulletOne}</Typography>
                      </li>
                      <br />
                      <li>
                        <Typography className="desc">{item.bulletTwo}</Typography>
                      </li>
                      <br />
                      <li>
                        <Typography className="desc">{item.bulletThree}</Typography>
                      </li>
                    </ul>
                  </span>
                )}
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid> 
    </div>
  );
}